import hoverintent from 'hoverintent'

const CWS_Theme = (
	function () {
		'use strict'

		const publicAPIs = {}

		publicAPIs.init = function ( options ) {
			// functions that need to wait for the DOM to load
			if ( document.readyState === "interactive" || document.readyState === "complete" ) {
				constructorEarly( options );
			} else {
				document.addEventListener( "DOMContentLoaded", constructorEarly, options );
			}

			// functions that need to wait for the DOM and images/stylesheets to load
			if ( document.readyState === "complete" ) {
				constructorLate( options );
			} else {
				window.addEventListener( "load", constructorLate, options );
			}
		}

		const constructorEarly = function () {
			// Header navigation
			initNavigation()

			// Carousels, provided by Flickity
			initCarousels()

			// Improve clickable regions on cards without damaging accessibility
			initClickableCards()

			// Hero video on homepage
			initHomepageHeroVideo()

			// Ajax load more button in news
			initAjaxLoadMore()

			// Email share link should copy the URL to clipboard
			initShareLinks()
		}

		const constructorLate = function () {
			// Stores max-height of specified elements as an inline CSS variable, so they can be animated. Recomputes after window resize.
			initStoreMaxHeights()
		}

		const initAjaxLoadMore = function () {
			const $button = document.getElementById( "cws-load-more" );
			if ( !$button ) return;

			if ( typeof cwsLoadMore === "undefined" || !cwsLoadMore.queryVars || !cwsLoadMore.currentPage || !cwsLoadMore.ajaxUrl || !cwsLoadMore.maxPage ) return

			$button.addEventListener( "click", function ( e ) {
				trigger_load_more( $button, e );
			} );

			function trigger_load_more( $button, e ) {
				e.preventDefault();
				$button.classList.add( "ajax-loading" );

				let data = {
					action: 'loadmore',
					queryVars: cwsLoadMore.queryVars,
					page: cwsLoadMore.currentPage,
					nonce: cwsLoadMore.nonce,
				};

				let dataEncoded = Object.keys( data ).map( function ( k ) {
					return encodeURIComponent( k ) + '=' + encodeURIComponent( data[k] )
				} ).join( '&' );

				const request = new XMLHttpRequest();
				request.open( 'POST', cwsLoadMore.ajaxUrl + '?' + new Date().getTime(), true );
				request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8' );

				request.onload = function () {
					$button.classList.remove( "ajax-loading" );
					if ( this.status >= 200 && this.status < 400 ) {
						let resp = this.response;
						if ( resp ) {
							document.getElementById( "archive-posts" ).insertAdjacentHTML( 'beforeend', resp );
							initClickableCards();
							cwsLoadMore.currentPage ++;
							if ( cwsLoadMore.currentPage === parseInt( cwsLoadMore.maxPage ) ) {
								$button.parentNode.removeChild( $button );
							}
						} else {
							$button.parentNode.removeChild( $button );
						}
					} else {
						console.log( this );
					}
				};

				request.onerror = function () {
					console.log( "connection error" );
				};

				request.send( dataEncoded );
			}
		}

		const initNavigation = function () {
			const nav = {};
			if ( !initNav() ) return;

			initToggleDropdownIfClickedEmptyMenuItem();
			initMobileDesktopToggle();
			initAccessibleFocusToggle();
			initHoverIntent();

			nav.button.addEventListener( 'click', function () {
				toggleMobileMenu( !nav.mobileNavExpanded )
			} )

			// Close expanded dropdowns and expanded mobile menu on click/keypress outside
			document.addEventListener( 'click', closeMenu );
			document.addEventListener( 'keydown', closeMenu );

			function closeMenu( event ) {
				const isClickOutside = !nav.siteNav.contains( event.target ) && !nav.button.contains( event.target );
				if ( isClickOutside ) {
					toggleMobileMenu( false )
				}
			}

			function initToggleDropdownIfClickedEmptyMenuItem() {
				for ( const link of nav.siteNavLinks ) {
					if ( !link.hasAttribute( "href" ) || link.getAttribute( "href" ) === "#" ) {
						link.addEventListener( "click", function ( e ) {
							if ( !nav.isDesktop ) {
								e.preventDefault();
								let self = e.target;
								while ( !self.classList.contains( 'menu-item-has-children' ) ) {
									self = self.parentNode
								}
								let checkbox = self.querySelector( "input" );
								if ( checkbox.checked ) {
									self.classList.remove( "focus" );
								}
								checkbox.checked = !checkbox.checked;
							}
						} );
					}
				}
			}

			function initNav() {
				nav.masthead = document.getElementById( 'masthead' )
				if ( !nav.masthead ) {
					return false
				}

				nav.siteNav = document.getElementById( "site-navigation" );
				if ( !nav.siteNav ) {
					return false
				}

				nav.button = masthead.getElementsByTagName( 'button' )[0]
				if ( 'undefined' === typeof nav.button ) {
					return false
				}

				nav.primaryMenu = document.getElementById( 'primary-menu' )
				if ( !nav.primaryMenu ) {
					nav.button.style.display = 'none'
					return false
				}

				nav.siteNavLinks = nav.siteNav.querySelectorAll( "a" );
				nav.siteNavTabbable = nav.siteNavLinks;
				nav.dropdownItems = nav.primaryMenu.querySelectorAll( ":scope > .menu-item-has-children" );
				nav.dropdownLinks = nav.primaryMenu.querySelectorAll( ":scope > .menu-item-has-children > a" );

				if ( !nav.primaryMenu.classList.contains( 'nav-menu' ) ) {
					nav.primaryMenu.classList.add( 'nav-menu' );
				}

				return true;
			}

			function initMobileDesktopToggle() {
				// store whether we're in mobile or not
				window.addEventListener( 'resize', function () {
					clearTimeout( nav.updateIsDesktopTimeout );
					nav.updateIsDesktopTimeout = setTimeout( updateIsDesktop, 100 );
				} )

				function updateIsDesktop() {
					nav.isDesktop = window.getComputedStyle( nav.button ).display === "none";
					if ( nav.isDesktop ) toggleMobileMenu( false );
					nav.siteNav.setAttribute( 'aria-expanded', nav.isDesktop );
				}

				updateIsDesktop()
			}

			// Toggle the .toggled class and the aria-expanded value
			function toggleMobileMenu( setTo ) {
				nav.mobileNavExpanded = setTo;
				nav.siteNav.setAttribute( 'aria-expanded', setTo );
				nav.button.setAttribute( 'aria-expanded', setTo );

				toggleTabindex( setTo );

				if ( setTo ) {
					nav.masthead.classList.add( 'toggled' );
				} else {
					nav.masthead.classList.remove( 'toggled' );
					for ( const item of nav.dropdownItems ) {
						item.classList.remove( "focus" );
					}
				}
			}

			function toggleTabindex( setTabIndexTo ) {
				for ( let link of nav.siteNavTabbable ) {
					if ( !setTabIndexTo && !nav.isDesktop ) {
						link.setAttribute( 'tabindex', - 1 );
					} else {
						link.setAttribute( 'tabindex', "" );
					}
				}
			}

			function initAccessibleFocusToggle() {
				// Toggle focus each time a menu link is focused or blurred.
				const links = nav.primaryMenu.getElementsByTagName( 'a' )
				for ( const link of links ) {
					link.addEventListener( 'focus', toggleFocus, true )
					link.addEventListener( 'blur', toggleFocus, true )
				}

				// Toggle focus each time a menu link with children receive a touch event.
				for ( const link of nav.dropdownLinks ) {
					link.addEventListener( 'touchstart', toggleFocus, {passive: true} )
				}

				// Sets or removes .focus class on an element.
				function toggleFocus( event ) {
					if ( event.type === 'focus' || event.type === 'blur' ) {
						let self = this
						while ( !self.classList.contains( 'nav-menu' ) ) {
							if ( 'li' === self.tagName.toLowerCase() ) {
								self.classList.toggle( 'focus' )
							}
							self = self.parentNode
						}
					}

					if ( event.type === 'touchstart' ) {
						if ( !this.parentNode.classList.contains( 'focus' ) ) {
							event.preventDefault()
							for ( const item of nav.dropdownItems ) {
								item.classList.remove( "focus" );
							}
							this.parentNode.classList.add( 'focus' )
						}
					}
				}
			}

			function initHoverIntent() {
				for ( const link of nav.dropdownLinks ) {
					hoverintent( link, hoverIntentOver, hoverIntentOut ).options( {
						timeout: 500,
						interval: 50,
						sensitivity: 10
					} );
				}

				function hoverIntentOver( e ) {
					let target = e.target;
					while ( target.classList !== undefined && !target.classList.contains( "menu-item-has-children" ) && target !== document ) {
						target = target.parentNode;
					}
					for ( const item of nav.dropdownItems ) {
						item.classList.remove( "hover-intent" );
					}
					target.classList.add( "hover-intent" );
				}

				function hoverIntentOut( e ) {
					let target = e.target;
					target.parentNode.classList.remove( "hover-intent" );
				}
			}
		}

		const initStoreMaxHeights = function () {
			const elts = document.querySelectorAll( '.js-store-max-height' )

			let resizeId
			window.addEventListener( 'resize', function () {
				clearTimeout( resizeId )
				resizeId = setTimeout( storeMaxHeights, 500 )
			} )

			function storeMaxHeights() {
				Array.prototype.forEach.call( elts, el => {
					el.style.maxHeight = 'none'
					el.style.setProperty( '--maxheight', window.getComputedStyle( el ).height )
					el.style.maxHeight = ''
				} )
			}

			storeMaxHeights()
		}

		const initCarousels = function () {
			if ( !document.querySelector( '.js-carousel' ) ) {
				return
			}
			let up, down, flkty = new Flickity( '.js-carousel', {
				groupCells: true,
				cellAlign: 'left',
				arrowShape: 'M 52.52079,97.87573 11.864344,54.69069 C 10.621353,53.37667 10,51.69046 10,50.00284 c 0,-1.68706 0.621637,-3.37525 1.864344,-4.68785 L 52.52079,2.1299445 c 2.592523,-2.73458002 6.906766,-2.84964499 9.639925,-0.266356 2.752478,2.592524 2.849644,6.9266542 0.266355,9.6427665 L 25.947072,50.00355 62.42707,88.50074 c 2.583715,2.71668 2.485981,7.03178 -0.266355,9.64277 -2.707589,2.57334 -7.026093,2.4597 -9.639925,-0.26778 z'
			} )
			// flickity is hijacking mousedown and mouseup, so re-add the card fake links manually within flickity sliders
			flkty.on( 'pointerDown', function ( e ) {
				self = e.target;
				while ( !self.classList.contains( "card-fake-link" ) && !self.classList.contains( "card" ) ) {
					self = self.parentNode;
				}
				if ( self.classList.contains( "card-fake-link" ) ) {
					if ( e.button === 0 ) {
						down = + new Date()
					}
				}
			} );
			flkty.on( 'pointerUp', function ( e ) {
				self = e.target;
				while ( !self.classList.contains( "card-fake-link" ) && !self.classList.contains( "card" ) ) {
					self = self.parentNode;
				}
				if ( self.classList.contains( "card-fake-link" ) ) {
					up = + new Date()
					if ( (up - down) < 200 ) {
						self.closest( ".card" ).querySelector( ".card-link" ).click();
					}
				}
			} );
		}

		const initClickableCards = function () {
			// in .card blocks, clicking on .card-fake-link triggers a click on .card-link
			// also, hovering over .card-link and .card-fake-link adds the .card-hover class to .card
			const cards = document.querySelectorAll( '.card' )
			Array.prototype.forEach.call( cards, card => {
				if ( card.getAttribute( "data-clickable" ) ) return;
				card.setAttribute( "data-clickable", true );
				let down,
					up,
					cardHoverClass = 'card-hover',
					link = card.querySelector( '.card-link' ),
					fakeLinks = card.querySelectorAll( '.card-fake-link' )
				if ( link ) {
					link.onmouseover = () => {
						card.classList.add( cardHoverClass )
					}
					link.onmouseout = () => {
						card.classList.remove( cardHoverClass )
					}
					if ( fakeLinks ) {
						Array.prototype.forEach.call( fakeLinks, fakeLink => {
							fakeLink.style.cursor = 'pointer'
							fakeLink.onmouseover = () => {
								card.classList.add( cardHoverClass )
							}
							fakeLink.onmouseout = () => {
								card.classList.remove( cardHoverClass )
							}
							fakeLink.onmousedown = ( e ) => {
								if ( e.button === 0 ) {
									down = + new Date()
								}
							}
							fakeLink.onmouseup = () => {
								up = + new Date()
								if ( (up - down) < 200 ) {
									link.click()
								}
							}
						} )
					}
				}
			} )
		}

		const initHomepageHeroVideo = function () {
			const $player = document.getElementById( 'hero-bg-video' )
			if ( !$player ) {
				return
			}

			let player,
				tag = document.createElement( 'script' ),
				firstScriptTag = document.getElementsByTagName( 'script' )[0]
			tag.src = 'https://www.youtube.com/iframe_api';
			firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

			window.onYouTubeIframeAPIReady = function () {
				player = new YT.Player( 'youtube-embedded-player', {
					videoId: videoId, allowfullscreen: 1, playerVars: {
						'autoplay': 1,
						'controls': 0,
						'enablejsapi': 1,
						'iv_load_policy': 3,
						'loop': 1,
						'modestbranding': 1,
						'playlist': videoId,
						'playsinline': 1,
						'rel': 0,
						'origin': origin
					}, events: {
						'onReady': function () {
							player.mute()
							player.playVideo()
						}, 'onStateChange': function ( el ) {
							if ( el.data === 1 ) {
								$player.classList.add( 'playing' )
							}
						}
					}
				} )
			}
		}

		const initShareLinks = function () {
			const elts = document.querySelectorAll( '.js-copy-on-click' )
			Array.prototype.forEach.call( elts, el => {
				el.addEventListener( 'click', copyLink );
			} )

			function copyLink( e ) {
				e.preventDefault();
				let self = e.target
				while ( 'a' !== self.tagName.toLowerCase() ) {
					self = self.parentNode
				}
				navigator.clipboard.writeText( self.getAttribute( "href" ) );
				self.classList.add( "js-url-copied" );
				setTimeout( function () {
					self.classList.remove( "js-url-copied" );
				}, 2000 );
			}
		}

		return publicAPIs
	}
)
()

CWS_Theme.init()
